import React from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';

class PortalComponent extends React.Component {
  constructor() {
    super();
    this.el = document.createElement('div');
    this.el.style.width = '100%';
  }

  componentDidMount() {
    const { id = 'portal-elements' } = this.props;
    this.portalElements = document.getElementById(id);
    this.portalElements.appendChild(this.el);
  }

  componentWillUnmount() {
    this.portalElements.removeChild(this.el);
  }

  render() {
    return ReactDOM.createPortal(this.props.children, this.el);
  }
}

PortalComponent.propTypes = {
  id: PropTypes.string,
  children: PropTypes.node,
};

export default PortalComponent;
